var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 bg-light form-modal"},[_c('button',{staticClass:"btn-close fa fa-times float-right",on:{"click":function($event){return _vm.hide()}}}),_c('h1',{staticClass:"big-title"},[_vm._v(" Contact Us ")]),_vm._m(0),_c('br'),_c('Form')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"sub-title"},[_c('span',[_vm._v(" Get a quote or ask a question")])])
}]

export { render, staticRenderFns }